import type { RouteRecordRaw } from 'vue-router'

import { AdokLayout as Layout } from '@/apps/adok/app/layout'

const MalwareScansPage = () =>
  import('@/apps/adok/pages/malware-scans').then((m) => m.MalwareScansPage)
const MalwareTasksPage = () =>
  import('@/apps/adok/pages/malware-tasks').then((m) => m.MalwareTasksPage)
const MalwareBlockersPage = () =>
  import('@/apps/adok/pages/malware-blockers').then(
    (m) => m.MalwareBlockersPage
  )

const malwareRoutes: RouteRecordRaw[] = [
  {
    path: '/malware-scans',
    component: Layout,
    children: [
      {
        path: '',
        name: 'malware-scans',
        component: MalwareScansPage,
        meta: {
          title: 'Malware scans'
        }
      },
      {
        path: 'new',
        name: 'malware-scans-new',
        component: MalwareScansPage,
        meta: {
          title: 'New malware scan',
          hidden: true
        }
      },
      {
        path: 'new/spot/:spotId',
        name: 'malware-scans-new-from-spot',
        component: MalwareScansPage,
        meta: {
          title: 'New malware scan',
          hidden: true
        }
      }
    ]
  },
  {
    path: '/malware-tasks',
    component: Layout,
    children: [
      {
        path: '',
        name: 'malware-tasks',
        component: MalwareTasksPage,
        meta: {
          title: 'Malware tasks'
        }
      }
    ]
  },
  {
    path: '/malware-blockers',
    component: Layout,
    children: [
      {
        path: '',
        name: 'malware-blockers',
        component: MalwareBlockersPage,
        meta: {
          title: 'Malware blockers'
        }
      }
    ]
  }
]

export default malwareRoutes
